'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';

/** Returns a debounced copy of `value` that updates at most once per `delay` ms. */
export function useDebounce(value, t0) {
  const $ = _c(4);
  const delay = t0 === undefined ? 250 : t0;
  const [debounced, setDebounced] = useState(value);
  let t1;
  let t2;
  if ($[0] !== delay || $[1] !== value) {
    t1 = () => {
      const timeout = setTimeout(() => setDebounced(value), delay);
      return () => clearTimeout(timeout);
    };
    t2 = [value, delay];
    $[0] = delay;
    $[1] = value;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return debounced;
}